export const cardColors = [
  "#FF8C32",
  "#95CD41",
  "#FFD31D",
  "#5f8cc5",
  "#77E4D4",
  "#F190B7",
];

export const cardBgColor = [
  "#fff3ea",
  "#f4faec",
  "#fffae8",
  "#f3f6f9",
  "#f1fcfa",
  "#fdf3f7",
];

export const timeFrame = [
  { label: "Last 24 hours", value: "lastDay" },
  // { label: "Last 7 Days", value: "lastSeven" },
  { label: "Last 7 days", value: "allHistory" },
];
export const events = [
  { label: "Jira Issue Created", value: "jira:issue_created" },
  { label: "Jira Issue Deleted", value: "jira:issue_deleted" },
  { label: "Jira Issue Updated", value: "jira:issue_updated" },
];
export const timeframeJobs = [
  { label: "Last 24 hours", value: 1 },
  { label: "Last 7 Days", value: 2 },
  { label: "All", value: 3 },
];
export const statusList = [
  { label: "Error", value: "Error" },
  { label: "Partial Success", value: "Partial Success" },
  { label: "Queued", value: "Queued" },
  { label: "Running", value: "Running" },
  { label: "Success", value: "Success" },
];
// UNKNOWNTYPE : "Unknown Type",
//   PAUSEBACKUP :"Pause Backups",
//   UNPAUSEBACKUP : "Resume Backups",
//   INITIATEBACKUP : "Initiate Backup",
//   INITIATERESTORE :"Initiate Restore",
//   DOWNLOADDATA : "Download Data",
//   APPACCESS:"App Access"
export const eventTypes = [
  { label: "Pause | Scheduled backups", value: "Pause | Scheduled backups" },
  { label: "Backup | On-demand", value: "Backup | On-demand" },
  { label: "Download Data", value: "Download Data" },
  {
    label: "Download | Backup jobs report",
    value: "Download | Backup jobs report",
  },
  { label: "App Access", value: "App Access" },
  { label: "Inclusion | Project", value: "Inclusion | Project" },
  { label: "Exclusion | Project", value: "Exclusion | Project" },
];
export const BackupEventTypes = [
  { label: "Pause | Scheduled backups", value: "Pause | Scheduled backups" },
  { label: "Backup | On-demand", value: "Backup | On-demand" },
  { label: "Download Data", value: "Download Data" },
  {
    label: "Download | Backup jobs report",
    value: "Download | Backup jobs report",
  },
  { label: "App Access", value: "App Access" },
  { label: "Inclusion | Project", value: "Inclusion | Project" },
  { label: "Exclusion | Project", value: "Exclusion | Project" },
];
export const RestoreEventTypes = [
  { label: "Initiate Restore", value: "Initiate Restore" },
  { label: "Download Data", value: "Download Data" },
  { label: "Restore | Issues data", value: "Restore | Issues data" },
  { label: "Restore | Config data", value: "Restore | Config data" },
  {
    label: "Download | Restore jobs report",
    value: "Download | Restore jobs report",
  },
  { label: "Download | Issues data", value: "Download | Issues data" },
  { label: "Download | Config data", value: "Download | Config data" },
  { label: "App Access", value: "App Access" },
];

export const restoreBasedOn = [
  { name: "restore", value: "tag", label: "Tag" },
  { name: "restore", value: "snapshotDate", label: "Snapshot Date" },
];

export const configTypes = [
  { value: "screens", label: "Screens" },
  { value: "workflows", label: "Workflows" },
];

export const restoreTypes = [
  {
    value: "restore_backed_up_issues_as_new_issues",
    label: "Create issues (as new issues)",
  },
  {
    // isDisabled: true,
    value: "restore_configuration",
    label: "Configurations",
  },
  {
    isDisabled: true,
    value: "restore_export",
    label: "Bulk export (coming soon)",
  },
  {
    isDisabled: true,
    value: "restore_content_in_existing_issue",
    label: "Update issues (coming soon)",
  },
];

export const pageSize = 50;

export const jobStatus = {
  1: "Queued",
  2: "Running",
  3: "Success",
  4: "Partial Success",
  5: "Error",
};

export const jobTypes = {
  1: "Configuration",
  0: "Issues",
  2: "Quick",
};
